import formatGmaddressFields from 'utils/format-gmaddress-fields.js';

/**
 * @name SignupShopController
 * @description Controller for the sign up shop process
 * @param {unknown} Session The session service
 * @param {unknown} ENDPOINT The Endpoint constant
 * @param {unknown} GMAPS_KEY The gmaps key constant
 * @param {unknown} NgMap The NgMap library for Google maps
 * @param {unknown} CheckUsername The check username service
 * @param {unknown} Shop The shop service
 * @param {unknown} Operators The operators service
 * @param {unknown} moment The moment library
 * @param {unknown} Association The associations service
 * @param {unknown} Auth The auth service
 * @param {unknown} $auth The satellizer $auth service
 * @param {unknown} $rootScope Angular $rootScope
 * @param {unknown} AUTH_EVENTS The auth events constant
 * @param {unknown} Events The events service
 * @param {unknown} AlertMessages The alert messages service
 * @param {unknown} Collector The collector service
 * @param {unknown} _ Lodash
 * @param {unknown} InkImage The image service
 * @param {unknown} Upload The upload library from ng-file-upload
 */
function SignupShopController(
  Session,
  ENDPOINT,
  GMAPS_KEY,
  NgMap,
  CheckUsername,
  Shop,
  Operators,
  moment,
  Association,
  Auth,
  $auth,
  $rootScope,
  AUTH_EVENTS,
  Events,
  AlertMessages,
  Collector,
  _,
  InkImage,
  Upload
) {
  let vm = this;

  vm.$onInit = function() {
    vm.shopTmp = {};
    vm.googleMapsUrl =
      'https://maps.googleapis.com/maps/api/js?&libraries=places&key=' +
      GMAPS_KEY;
    vm.placeChanged = placeChanged;
    vm.checkUsername = checkUsername;
    vm.createShop = createShop;
    vm.getFullLogo = getFullLogo;
    vm.remove = remove;
    vm.uploadFullLogo = uploadFullLogo;
    vm.createdShop = {};
    vm.createdAssociation = {};
    vm.steps = [
      {
        id: 1,
        name: 'create-collector',
        title: 'Create your collector profile'
      },
      {
        id: 2,
        name: 'update-collector',
        title: 'Complete your personal profile'
      },
      {
        id: 3,
        name: 'create-shop',
        title: 'Create your shop profile'
      }
    ];
    vm.activeStep = _.find(vm.steps, {name: 'create-shop'});
  };

  /**
   * @name placeChanged
   * @description Google maps autocomplete
   */
  function placeChanged() {
    vm.place = this.getPlace(); // Use of 'this' is based on the library
    formatGmaddressFields(vm.place.address_components).then(addressFields => {
      Object.assign(vm.shopTmp, addressFields);
    });
    vm.shopTmp.gmaddress = vm.place.formatted_address;
    vm.gmaddressTmp = vm.place.formatted_address;
    vm.shopTmp.lat = vm.place.geometry.location.lat();
    vm.shopTmp.lng = vm.place.geometry.location.lng();
    vm.shopTmp.gmaddress_url = vm.place.url;
    vm.map.setCenter(vm.place.geometry.location);
  }

  NgMap.getMap().then(function(map) {
    vm.map = map;
  });

  /**
   * @name checkUsername
   * @description Function to check if a username exists when setting one
   * @param {string} username The username to check
   */
  function checkUsername(username) {
    CheckUsername.check(username, vm.currentShopUsername).then(function(
      results
    ) {
      vm.usernameResults = results;
    });
  }

  /**
   * @name getFullLogo
   * @description Function to get the shop full logo
   * @param {number} imageId The ID of the new full logo
   */
  function getFullLogo(imageId) {
    InkImage.get(imageId).then(function(fullLogo) {
      vm.fullLogo = fullLogo;
    });
  }

  /**
   * @name uploadFullLogo
   * @description Function to upload the shop full logo
   * @param {file} file The file to upload
   * @param {array} errFiles Errors array
   */
  function uploadFullLogo(file, errFiles) {
    vm.f = file;
    vm.errFile = errFiles && errFiles[0];
    if (file) {
      file.upload = Upload.upload({
        url: ENDPOINT.server + 'inkutils/api/v1.1/image/',
        data: {file: file}
      });
      file.upload.then(
        function(response) {
          file.result = response.data;
          vm.shopTmp.full_logo = file.result.id;
          getFullLogo(file.result.id);
        },
        function(response) {
          if (response.status > 0) {
            vm.errorMsg = response.status + ': ' + response.data;
          }
        },
        function(evt) {
          file.progress = Math.min(
            100,
            parseInt(100.0 * evt.loaded / evt.total, 10)
          );
        }
      );
    }
  }

  /**
   * @name remove
   * @description Function to remove the profile image
   * @param {number} imageId The image to remove
   */
  function remove(imageId) {
    let file = '';
    InkImage.remove(imageId, file).then(function(image) {
      vm.fullLogo.image = null;
      vm.shopTmp.full_logo = '';
    });
  }

  /**
   * @name createShop
   * @description Function to create a shop object. When this is run, an
   * operator and association is created and connected to the shop.
   * @param {object} shop The data from the form.
   */
  function createShop(shop) {
    Shop.add(shop)
      .then(function(newShop) {
        vm.createdShop = newShop;
        let _collector = {
          collector_id: Session.collector.id,
          shop_id: vm.createdShop.id,
          role: 'Operator'
        };
        return Operators.create(_collector);
      })
      .then(function(updatedCollector) {
        vm.updatedCollector = updatedCollector;
        let type = 'Operator';
        let _association = {
          collector_id: updatedCollector.id,
          shop_id: vm.createdShop.id,
          status: 'Confirmed',
          startDatetime: moment().format(),
          operatorAdmin: true,
          operatorOwner: true,
          can_update_appts: true
        };
        return Association.createAssociation(type, _association);
      })
      .then(function(association) {
        vm.createdAssociation = association;
        return Collector.getCollector(vm.updatedCollector.id);
      })
      .then(function(_collector) {
        let roles = Auth.getRoles(_collector);
        Session.create($auth.getToken(), roles, _collector);
        return Collector.getCollector(vm.updatedCollector.id);
      })
      .then(function(_collector) {
        return Auth.setState(_collector);
      })
      .then(function() {
        $rootScope.$broadcast(AUTH_EVENTS.loginSuccess);
        Events.loggedIn = true;
        Auth.routeAfterAuthentication();
      })
      .catch(function(error) {
        AlertMessages.add({
          msg: error,
          type: 'danger'
        });
      });
  }
}

angular
  .module('inkfinder')
  .controller('SignupShopController', SignupShopController);



// WEBPACK FOOTER //
// ./components/signup/shop/signup.shop.controller.js